import ReactGA from 'react-ga';

type TrackerName = 'user' | 'global';

type TrackerAPI = {
	'user': string,
	'global': string
};

interface EventProps {
	category: string,
	action: string,
	label?: string
}

interface Tracker {
	trackingId: string,
	gaOptions: {
		name: TrackerName
	}
}

export const setupTracking = (trackers: TrackerAPI) => {
	const gaTrackers: Tracker[] = [];

	for (const trackerType in trackers) {
		const trackerName = trackerType as TrackerName;
		const trackingId = trackers[trackerName];

		gaTrackers.push({
			trackingId: trackingId,
			gaOptions: {
				name: trackerName
			}
		});
	}

	ReactGA.initialize(
		gaTrackers,
		{debug: process.env.NODE_ENV === 'development'}
	);
}

export const useTracking = () => {
	const event = ({category, action, label}: EventProps, type?: TrackerName) : void => {
		ReactGA.event({category, action, label}, [type || 'global']);
	}

	return [event];
}
